var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video",attrs:{"id":"video","src":_vm.mediaurl,"controls":"true","poster":_vm.imgurl,"preload":"auto","webkit-playsinline":"true","playsinline":"true","x-webkit-airplay":"allow","x5-video-player-type":"h5","x5-video-player-fullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }